

































import Vue from 'vue';
import _ from 'lodash';
import { calculoIdadeGestacional, getDpp, montaFlagsAarray } from '../../utils/functions';
import { Paciente } from '../../../../back/src/entity/Paciente';
import { Gestacao } from '../../../../back/src/entity/Gestacao';

export default Vue.extend({
  name: 'PacienteBotaoCopiaDados',
  props: {
    paciente: {
      type: Object as () => Paciente,
    },
    gestacao: {
      type: Object as () => Gestacao,
    },
    tiny: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    dadosGestanteCopy(): string {
      if (!this.gestacao) {
        return '';
      }
      let observacoes = 'Nada consta';
      if (this.paciente.observacoes) {
        observacoes = _.replace(this.paciente.observacoes, /\n+/g, ' ');
      }
      const dpp = getDpp(this.paciente.gestacao_atual);
      return `${this.paciente.nome}
DPP ${dpp ? dpp.format('DD/MM/YY') : 'Nada consta'}
IG ${dpp ? calculoIdadeGestacional(this.gestacao) : 'Nada consta'}
${this.paciente.paridade ? this.paciente.paridade : '(Não consta paridade)'}
${this.gestacao.local_parto ? this.gestacao.local_parto : '(Não consta local de parto)'}
Pediatra: ${this.gestacao.pediatra ? this.gestacao.pediatra : 'Nada consta'}${this.montaTextoFlags(this.getflags())}
${this.paciente.cidade !== 'São Paulo' ? this.paciente.cidade : this.paciente.bairro} - ${this.paciente.telefone2 ? `${this.paciente.telefone1} / ${this.paciente.telefone2}` : this.paciente.telefone1}
Observações: ${observacoes}`;
    },
    clipboardCopySuccess() {
      this.$root.$emit('avisoSnackbar', { color: 'info', text: 'Dados da gestante copiados para a área de transferência.' });
    },
    clipboardCopyError() {
      this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Não foi possível copiar os dados da gestante.' });
    },
    montaTextoFlags(flags) {
      if (flags.length === 0) {
        return '';
      }
      let flagsText = '';
      _.forEach(flags, (flag) => {
        flagsText = `${flag.sigla}, ${flagsText}`;
      });
      return `
(${flagsText.substring(0, flagsText.length - 2)})`;
    },
    getflags(): { sigla: string, descricao: string, color: string }[] {
      return montaFlagsAarray(this.gestacao);
    },
  },
});
